import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DesignAngularKitModule } from 'design-angular-kit';
import { RequestCreateDto, RequestDto } from '../../models/request.dto';

@Component({
  selector: 'app-request-summary',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule],
  templateUrl: './request-summary.component.html',
  styleUrl: './request-summary.component.scss',
})
export class RequestSummaryComponent {
  @Input() request: RequestDto | RequestCreateDto | undefined;
}
